import { types } from "../types/types";
const intitalState = {
    styleGuides: [],
    styleGuideDetails: {},
};

const styleGuideReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.STYLE_GUIDES:
            return {
                ...state,
                styleGuides: action.payload,
            };
        case types.STYLE_GUIDES_DETAILS:
            return {
                ...state,
                styleGuideDetails: action.payload,
            };
        default:
            return { ...state };
    }
};

export default styleGuideReducer;
